import en from './locales/en.json'
import sk from './locales/sk.json'
import ua from './locales/ua.json'
import { getCookie } from '../../../utils/cookies'

export const defaultLocale = getCookie('locale') ? getCookie('locale') : 'sk'

// route names, ktoré majú ukrajinský preklad - /ua funguje len na nich
export const uaRoutes = ['DruzstevneByvanie', 'Bory Bývanie Na Hrádzi']

export const languages = {
  en: en,
  sk: sk,
  ua: ua,
}

